/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';
import { BackendPatchedCreditRequestDto } from '../../models/backend-patched-credit-request-dto';

export interface FinancingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this кредит.
   */
  id: number;
  body?: BackendPatchedCreditRequestDto;
}

export function financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditDto>;
    }),
  );
}

financingSourcesCreditsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/financing_sources/credits/{id}/';
